import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { MatError, MatFormField, MatInput } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { SubjectEntity } from '../../subject/subject.entity';
import { COUNTRIES_DATA } from '../../../../fixtures/fixtures';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatLabel } from '@angular/material/form-field';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'pixl-form-dialog-subject',
  templateUrl: './form-dialog-subject.component.html',
  imports: [
    CommonModule,
    MatFormField,
    MatFormField,
    ReactiveFormsModule,
    FormsModule,
    MatDialogContent,
    MatDialogActions,
    MatOption,
    MatSelect,
    MatDialogTitle,
    MatInput,
    MatButton,
    MatLabel,
    MatError,
    TranslocoPipe
  ],
  styleUrls: ['./form-dialog-subject.component.scss']
})
export class FormDialogSubjectComponent {
  form: FormGroup;
  public readonly countries: string[] = COUNTRIES_DATA;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<FormDialogSubjectComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: Partial<SubjectEntity>
  ) {
    this.form = this.fb.group({
      name: [data?.name || ''],
      region: [data?.region || '-1'],
    });
  }

  save(): void {
    if (this.form.valid) {
      const formValue = this.form.value;

      const updatedSubject = Object.assign(
        new SubjectEntity(),
        { id: this.data?.id },
        formValue
      );

      this.dialogRef.close(updatedSubject);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  public checkForErrors(formControl: AbstractControl): string {
    if (formControl.hasError('required')) {
      return 'Eingabe erforderlich';
    }

    return '';
  }
}
